

// import React, { useState , useEffect} from "react";
// import { Link } from "react-router-dom";
// import styles from './resetPasswordForm.module.css';
// import { FcGoogle } from "react-icons/fc";
// import { useNavigate } from 'react-router-dom';

// import { useAuth } from '../../global_state_components/AuthProvider';

// import { useGoogleLogin } from '@react-oauth/google';
// import { axiosInstance } from "../../../lib/axiosInstance";
// import toast from 'react-hot-toast';
// import { useGlobalState } from "../../global_state_components/GlobalStateProvider";



// function ResetPasswordForm() {
//   const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

//   const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx

//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [lengthMessage, setLengthMessage] = useState("");

//   const handleResetPassword = async (e) => {
//     e.preventDefault();

//     // Check if password length is atleast 6.
//     if (password.length < 6){
//       setLengthMessage("New password must be atleast 6 characters.");
//       return;
//     }

//     if (password.length > 6){
//       setLengthMessage("");
//     }


//     // Check if passwords match
//     if (password !== confirmPassword) {
//       setErrorMessage("Passwords do not match!");
//       return;
//     }

//     try {
//       setErrorMessage(""); // Clear any previous errors
//       const response = await axiosInstance.post("/auth/reset-password", { password });
//       setSuccessMessage("Password reset successful!");
//     } catch (error) {
//       setErrorMessage(error.response?.data?.message || "An error occurred!");
//     }
//   };



//   return(
//     <div className={styles.inner_container}>
//       <h1 className={styles.welcome_title}>
//         Reset your password
//       </h1>
//       <form onSubmit={handleResetPassword}>
//         <input
//           className={styles.input}
//           type="password"
//           placeholder="New password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />
//         {lengthMessage && <p style={{ color: "red" }}>New password must be atleast 6 characters long.</p>}
//         {/* <small>At least 6 characters</small> */}
//         <input
//           className={styles.input}
//           type="password"
//           placeholder="New password, again"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//           required
//         />
//         {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
//         {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}

//         <button 
//           className={styles.signup_button} 
//           type="submit"
//         >
//           Reset password
//         </button>
//       </form>
              
//       <div className={styles.already_account_div}>
//         <p className={styles.already_account_p_tag}>Don't have an account?</p>
//         <Link className={styles.link} to="/signup"><span>Sign up</span></Link>
//       </div>
//     </div>
//   );
// }

// export default ResetPasswordForm;













//----------------------












import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import styles from './resetPasswordForm.module.css';
import { FcGoogle } from "react-icons/fc";
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../global_state_components/AuthProvider';

import { useGoogleLogin } from '@react-oauth/google';
import { axiosInstance } from "../../../lib/axiosInstance";
//import toast from 'react-hot-toast';
import { useGlobalState } from "../../global_state_components/GlobalStateProvider";



function ResetPasswordForm() {
  const location = useLocation();

  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

  const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [lengthMessage, setLengthMessage] = useState("");

  // Extract the token from the URL
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get('email');
  const tokenAndEmailAndPassword = {
    email: email,
    token: token,
    newPassword: password
  }

  const [isPasswordReset, setIsPasswordReset] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Check if password length is atleast 6.
    if (password.length < 6){
      setLengthMessage("New password must be atleast 6 characters.");
      return;
    }

    if (password.length > 6){
      setLengthMessage("");
    }


    // Check if passwords match
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    try {
      setErrorMessage(""); // Clear any previous errors
      const response = await axiosInstance.post("/auth/reset-password", tokenAndEmailAndPassword);
      setSuccessMessage("Password reset successful!");
      setIsPasswordReset(true);
      //navigate("/signin");
    } catch (error) {
      if (error.response.status===400){
        setErrorMessage("Bad request - Your reset link might have timed out. Request an new one.")
      }else{
        setErrorMessage(
          (Array.isArray(error.response?.data?.message)? error.response?.data?.message[0] : error.response?.data?.message) 
          || 
          "An error occurred!"
        );
      }

      //-----------------
      if (error.response) {
        // Server responded with a status other than 200 range
        console.log("Error Data: ", error.response.data);
        console.log("Error Status: ", error.response.status);
        console.log("Error Headers: ", error.response.headers);
      } else if (error.request) {
        // Request was made but no response was received
        console.log("Error Request: ", error.request);
      } else {
        // Something else happened
        console.log("Error Message: ", error.message);
      }
    }
  };



  return(
    (isPasswordReset === false)?( 
                                  <div className={styles.inner_container}>
                                    <h1 className={styles.welcome_title}>
                                      Reset your password
                                    </h1>
                                    <form onSubmit={handleResetPassword}>
                                      <input
                                        className={styles.input}
                                        type="password"
                                        placeholder="New password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                      />
                                      {lengthMessage && <p style={{ color: "red" }}>New password must be atleast 6 characters long.</p>}
                                      {/* <small>At least 6 characters</small> */}
                                      <input
                                        className={styles.input}
                                        type="password"
                                        placeholder="New password, again"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                      />
                                      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                                      {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}

                                      <button 
                                        className={styles.signup_button} 
                                        type="submit"
                                      >
                                        Reset password
                                      </button>
                                    </form>
                                            
                                    <div className={styles.already_account_div}>
                                      <p className={styles.already_account_p_tag}>Reset link timed out?</p>
                                      <Link className={styles.link} to="/auth/forgot-password"><span>Request new link</span></Link>
                                    </div>
                                  </div>
                                ):(
                                  <div className={styles.inner_container}>
                                    <h1 className={styles.welcome_title}>
                                      Password has been reset
                                    </h1>
                                    <form>
                                      <button className={styles.signup_button} onClick={() => navigate("/signin")}>Go back to Login</button>
                                    </form>
                                            
                                    <div className={styles.already_account_div}>
                                      <p className={styles.already_account_p_tag}>Don't have an account?</p>
                                      <Link className={styles.link} to="/signup"><span>Sign up</span></Link>
                                    </div>
                                  </div>
                                )
  );
}

export default ResetPasswordForm;





















